import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bike-live-map',
  templateUrl: './bike-live-map.component.html',
  styleUrls: ['./bike-live-map.component.scss']
})
export class BikeLiveMapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
